import React, { useEffect, useState } from 'react';
import { getIcons } from '_helpers';
import { BatteryIndicatorHorizontal/*, BatteryIndicatorVertical*/ }  from '_components/battery';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { sidePanelActions } from '_store/sidePanel.slice';

export { SidePanelCard };
 
/**
 * Encart coloré présent dans la section lattérale contenant les informations du bus
 * La couleur de fond dépend du niveau de l'événement retenu
 * @param {*} param0 
 * @returns 
 */
function SidePanelCard({ data }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getVehicleMode = (value) => {
        switch (value) {
            case(1):
                return ('Standby'); 
            case(2): 
                return ('Driving'); 
            case(3): 
                return ('Charging');
            default :
                return 'N/A';
        }
    }

    const {
        conduite = getVehicleMode(data.CONTEXT?.VHM),
        kms = data.CONTEXT?.RANGE ?? 'N/A',
        flotte = data.METROPOLIS ?? 'N/A',
        tensionBatterie = data.CONTEXT?.TBC ?? 'N/A',
        courantBatterie = data.CONTEXT?.TBV ?? 'N/A',
        socActuel = data.CONTEXT?.SOC ?? 0,
        //nombreBatteries = data.CONTEXT?.PCKS ?? 0,
    } = data;

    const [color, setColor] = useState('blue');

    useEffect(() => {
        if (data.URGENCY_LEVEL){
            switch (data.URGENCY_LEVEL) {
                case ("3"):
                    setColor('orange');
                    break;
                case ("4"):
                    setColor('red');
                    break;
                default:
                    setColor('blue');
                    break;;
            }
        }
    }, [data])

    const handleViewFleet = () => {
        dispatch(sidePanelActions.closePanel()); 
        navigate(`/donnees/flotte/${data.METROPOLIS}`)
    }

    const handleViewBus = () => {
        dispatch(sidePanelActions.closePanel()); 
        navigate(`/donnees/bus/${data.HEADER_VIN}`)
    }
        

    return (
        <div className={`side-panel-card ${color}`}>
            <div className="left-section">
                <div className="left-section-item-v cursor-pointer" onClick={handleViewBus}>
                    <div className="label">VIN :</div>
                    <div className="value">{data.HEADER_VIN}</div>
                </div>
                <div className="left-section-item-h">
                    <div className='h-full mr-1'>
                        <img className='h-full' src={getIcons('busAlertOutlinedWhite')} alt='bus icon'/>
                    </div>
                    <div className="details-section">
                        <div className='flex'>
                            <div className='label'>Niveau: </div>
                            <div className='value'>{data.URGENCY_LEVEL === '4' ? ' Stop 4' :  (data.URGENCY_LEVEL === '3' ? ' Alerte 3' : (data.URGENCY_LEVEL === '' ? ' Pré-Alerte' : ` Niveau ${data.URGENCY_LEVEL}`))}</div>
                        </div>
                        <div className='flex'>
                            <div className="label">Conduite: </div>
                            <div className='value'> {conduite}</div>
                        </div>
                    </div>
                </div>
                <div className="left-section-item-h">
                    <div className="big-number">{kms}</div>
                    <div className="details-section text-xs">
                        <div>km d'autonomie</div>
                    </div>
                </div>
            </div>
            <div className="right-section">
                <div className="right-section-top">
                    <div className="icon-group details-section">
                        <div className="icon"><img className='h-full mr-1' src={getIcons('mapOutlinedWhite')} alt='bus icon'/></div>
                        <div className="label">Pays</div>
                        <div className="value">{data.COUNTRY}</div>
                    </div>
                    <div className="icon-group details-section cursor-pointer" onClick={handleViewFleet}>
                        <div className="icon"><img className='h-full mr-1' src={getIcons('warehouseOutlinedWhite')} alt='bus icon'/></div>
                        <div className="label">Flotte</div>
                        <div className="value">{flotte}</div>
                    </div>
                    <div className="icon-group details-section">
                        <div className="icon"><img className='h-full mr-1' src={getIcons('directionsBusFilledOutlinedWhite')} alt='bus icon'/></div>
                        <div className="label">Parc</div>
                        <div className="value">{data.PARK_NUMBER}</div>
                    </div>
                    <div className="icon-group details-section">
                        <div className="icon"><img className='h-full mr-1' src={getIcons('constructionOutlined')} alt='bus icon'/></div>
                        <div className="label">WDS</div>
                        <div className="value">{data.WSD}</div>
                    </div>
                </div>
                <div className="right-section-bottom mt-4">
                    <div className="battery-info w-[40%]">
                        <div className="big-number">{tensionBatterie} V</div>
                        <div className="label details-section">Tension batterie</div>
                        <div className="big-number">{courantBatterie} A</div>
                        <div className="label details-section">Courant batterie</div>
                    </div>
                    <div className="battery-status w-[60%]">
                        <div className="battery-soc w-[full]">
                            <div className="label details-section">SOC</div>
                            <BatteryIndicatorHorizontal percentage={socActuel} />
                        </div>
                        {/*<div className="battery-count mt-2 max-h-12">
                            {[...Array(nombreBatteries)].map((_, index) => (
                                < BatteryIndicatorVertical percentage={socActuel} key={index} index={index}/>
                            ))}
                        </div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};
